import type { IUserType } from '@/modules/user/types/IUserType'
import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

export const PORTAL_ADMINISTRATOR_ROLE = 'Администратор портала'

export function canAccessPortalSettings(_user?: IUserType | null): boolean {
  const permissionsStore = usePermissionsStore()
  if (permissionsStore.isSuperuser)
    return true
  const hospital = permissionsStore.modules.hospital
  return !!(hospital?.settings_edit || hospital?.structure_edit || permissionsStore.modules.integrations?.manage)
}
